import FacePageHeader from '@/components/layout/FacePageHeader';
import { Button } from '@/components/ui/button';
import { Link, useLocation } from 'react-router-dom';
import { NotFoundAction } from './types';
import { PageHeader, PageMain, PageShell } from '@/components/layout/PageShell';
import { useEffect } from 'react';

const notFoundAction: NotFoundAction = {
  label: 'На главную',
  to: '/'
};

const NotFoundPage = () => {
  const location = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <PageShell
      contentVariant="face"
      headerMode="static"
    >
      <PageHeader>
        <FacePageHeader />
      </PageHeader>

      <PageMain contentClassName="flex flex-1 items-center justify-center">
        <section className="flex flex-col items-center gap-4 text-center">
          <h1 className="font-sans text-4xl font-semibold leading-tight text-foreground">404</h1>
          <p className="font-sans text-sm leading-5 text-muted-foreground">Страница не найдена</p>
          <Button asChild>
            <Link to={notFoundAction.to}>
              {notFoundAction.label}
            </Link>
          </Button>
        </section>
      </PageMain>
    </PageShell>
  );
};

export default NotFoundPage;